import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

function LoginPage() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const auth = getAuth();
      const email = `${userId}@placeholder.com`.toLowerCase();
      console.log('🚀 로그인 시도:', email);
      const result = await signInWithEmailAndPassword(auth, email, password);

      if (result.user) {
        console.log('✅ 로그인 성공:', result.user);

        // Firestore에서 역할 조회 - userId 필드 기준으로 검색
        const q = query(collection(db, 'users'), where('userId', '==', userId));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const userData = snapshot.docs[0].data();
          const role = userData.role || 'student';

          localStorage.setItem('user', JSON.stringify({ id: userId, uid: result.user.uid, role }));

          if (role === 'admin') {
            window.location.href = '/admin';
          } else if (role === 'instructor') {
            window.location.href = '/instructor';
          } else {
            window.location.href = '/student';
          }
        } else {
          setError('로그인 정보는 맞지만 사용자 정보가 등록되지 않았습니다.');
        }
      }
    } catch (err) {
      console.error('❌ 로그인 실패:', err.code, err.message);
      setError('아이디 또는 비밀번호가 올바르지 않거나 승인되지 않은 계정입니다.');
    }
  };

  return (
    <div style={{ backgroundColor: '#f4f4f4', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '400px' }}>
        <h1 style={{ textAlign: 'center', color: '#00704A', marginBottom: '30px' }}>🔐 수학의진수 로그인</h1>

        {error && <p style={{ color: 'red', fontSize: '0.9rem', marginBottom: '20px', textAlign: 'center' }}>{error}</p>}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>아이디</label>
            <input
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
              placeholder="아이디 입력"
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem' }}
            />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>비밀번호</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="비밀번호 입력"
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem' }}
            />
          </div>

          <button
            type="submit"
            style={{ width: '100%', padding: '14px', backgroundColor: '#00704A', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer' }}
          >
            로그인
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
